import React from "react";

import { BoxForms } from "../../containers/boxesOraculo/BoxForms";
import { BoxTypes } from "../../containers/boxesOraculo/BoxTypes";

import { Drawer } from "../../components/Drawer";
import { Empty } from "../../components/Empty";

export class NodeDrawer extends React.Component {
  state = {
    selectedNode: null,
  };

  componentDidMount() {
    const { node } = this.props;

    this.setState({
      selectedNode: node,
    });
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.visible && this.props.visible) {
      this.setState({
        selectedNode: this.props.node,
      });
    }
  }

  renderForm() {
    const { selectedNode } = this.state;
    const { visible, onClose, onSave, flowType, restrictions, boxes } = this.props;

    if (BoxForms[selectedNode.type]) {
      const FormComponent = BoxForms[selectedNode.type];

      const creativesActions = [
        BoxTypes.SmsCreativeAction,
        BoxTypes.EmailCreativeAction,
        BoxTypes.PushCreativeAction,
        BoxTypes.WhatsAppCreativeAction,
      ];

      const isCreativeAction =
        creativesActions.includes(selectedNode.type) &&
        selectedNode.type !== "CreativeGroupAction";

      return (
        <FormComponent
          key={`box-${selectedNode.id}`}
          node={selectedNode}
          flowType={flowType}
          restrictions={restrictions}
          onChange={(node) => {
            this.setState({ selectedNode: node });
          }}
          visible={visible}
          onClose={onClose}
          boxes={boxes}
          onSave={(node, close) => {
            onSave && onSave(node, close);
          }}
          isCreativeAction={isCreativeAction}
        />
      );
    }

    return (
      <Drawer visible={visible} onClose={onClose}>
        <Empty>
          <i className="far fa-arrows-split-up-and-left"></i>
          <p>Não há configurações.</p>
          <span>Não existem configurações para essa box</span>
        </Empty>
      </Drawer>
    );
  }

  render() {
    const { selectedNode } = this.state;

    return selectedNode && this.renderForm();
  }
}
